/**
 * Loading fallback для React.lazy роутов и Suspense boundary'ев.
 *
 * Stage 5.X.1: простой текст. Stage 5.X.3+ заменим на skeleton-shimmer
 * соответствующих компонентов (см. docs/tg-miniapp.md §6).
 */
export function LoadingFallback(): JSX.Element {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100dvh',
        color: 'var(--text-secondary-1)',
        fontFamily: 'var(--font-body)',
        fontSize: 'var(--fs-7)',
      }}
    >
      Загрузка…
    </div>
  );
}
